/**
* @ngdoc directive
* @name Prevent Change By Browser
*
* @element input(type='number')
*
* @description
  Prevent change of input value by browser on mousewheel, up/down click
*
* @example
  <div ng-init='number=1'>
  <input type='number' prevent-change-by-browser placeholder="Number" ng-model='number' />
  </div>
*/

(function() {
  'use strict';

  app.directive('preventChangeByBrowser', directive);

  function directive() {
    return {
      require: 'ngModel',
      link: link
    };

    function link(scope, element) {
      element
        .on('mousewheel', function(event) {
          // do not increase/decrease on scroll up/down
          event.preventDefault();
        })
        .on('keydown', function(event) {
          // do not increase/decrease on keyup/keydown
          if ([38, 40].indexOf(event.keyCode) > -1) event.preventDefault();
        });
    }
  }

})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/preventChangeByBrowser.js